"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.COMPANY_KEYS = void 0;
/**
 * The company provider's key space. These are the names WITHOUT the
 * `company_` prefix that `companyMergeFields` adds.
 *
 * Adding a key here and not producing it in `companyMergeFields` is a COMPILE
 * ERROR (that function `satisfies Record<CompanyKey, string | undefined>`).
 * That is the whole point: you cannot declare a field the platform has no code
 * path to fill.
 */
exports.COMPANY_KEYS = [
    'legal_name', 'dba', 'display_name', 'entity_type', 'state_of_formation', 'ein',
    'address', 'mailing_address', 'city', 'state', 'postal_code',
    'phone', 'website',
    'support_email', 'billing_email', 'accounts_email', 'sales_email', 'admin_email',
    'governing_law_state', 'venue_county',
    /**
     * WHO SIGNS FOR US, so an agreement can print "By: Dana Reyes, Chief
     * Executive Officer" above our signature line instead of leaving it to be
     * typed per contract. Resolved per agreement — the profile's default, or the
     * specific signatory that agreement named.
     */
    'signatory_name', 'signatory_title',
];
//# sourceMappingURL=company.js.map